import { DeleteIcon, SearchIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Heading,
  Tr,
  useColorModeValue,
  useToast,
  useDisclosure,
  Checkbox,
  SimpleGrid,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  ModalFooter,
  Center,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import Default from 'components/fields/InputField';
import { useRef, useState, useCallback, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { HSeparator } from 'components/separator/Separator';
import InterfaceSelect from 'components/select';
// import { useParams } from 'react-router-dom';
import TableSkeleton from './components/tableSkeleton';
import AssetParamDialog from './modal/assetParam';
import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';
import { useLocation, useNavigate } from 'react-router-dom';
import GlobalAlertDialog from 'components/GlobalAlertDialog';
import GlobalModal from 'components/GlobalModal';
import {
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
} from '@chakra-ui/icons';
import { version } from 'jszip';

export default function Configure() {
  const toast = useToast();
  const location = useLocation();
  const GRIDX_TYPE = localStorage.getItem('deviceType');
  const navigate = useNavigate();
  // const devicesArray = location.state?.devicesArray;
  const cardBg = useColorModeValue('white', 'navy.700');
  const textColor = useColorModeValue('navy.700', 'white');
  const inputBg = useColorModeValue('white', 'navy.600');
  // const skeletonBg = useColorModeValue('navy.50', 'navy.100');
  const [configName, setConfigName] = useState('');
  const [configId, setConfigId] = useState(null);
  // const { deviceUUID } = useParams();
  const deviceId = localStorage.getItem('deviceId');
  const isFirstRender = useRef(true);
  const [selectedDevices, setSelectedDevices] = useState([deviceId]);
  const [serialNumber, setSerialNumber] = useState('');
  const {
    isOpen: isOpenSaveConf,
    onOpen: DeviceSaveConf,
    onClose: onCloseSaveConf,
  } = useDisclosure();

  const onOpenSaveConf = () => {
    setSelectedDevices([deviceId]);
    DeviceSaveConf();
  };

  const [configurations, setConfigurations] = useState([]);
  // const [slavesToDelete, setSlavesToDelete] = useState([]);
  const [originalData, setOriginalData] = useState({});
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openAssetMastermodel, setAssetMasterOpen] = useState(false);
  const [currentSlaveId, setCurrentSlaveId] = useState(null);
  const [deviceType, setDeviceType] = useState(1);
  const [maxSlavePerDevice, setMaxSlavePerDevice] = useState(1);
  const [maxSlavePerInterFace, setMaxSlavePerInterFace] = useState(1);
  const [maxSlaveParameters, setMaxSlaveParameters] = useState(1);
  // const [modbusConfigVersion, setModbusConfigVersion] = useState(1);
  const [loadingDevices, setLoadingDevices] = useState(false);
  const [devicesArray, setDevicesArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(-1);
  const [hasNext, setHasNext] = useState(false);
  const [interfaceList, setInterfaceList] = useState([]);
  // Add a new state to store interface settings by interface_id
  const [interfaceSettingsMap, setInterfaceSettingsMap] = useState({});

  const closeAssetParameterModal = () => {
    setAssetMasterOpen(false);
  };

  const fetchAllDevices = useCallback(
    async (serialNumber = '', setLoading = true, page = 0) => {
      setLoadingDevices(setLoading);

      const resp = await axiosInstance.get(
        apiUrls.allDevices(serialNumber, page),
      );

      const devices = resp.data.data;
      setHasNext(resp.data.hasNext);

      const devicesNameIdMap = devices.map((d) => ({
        id: d.name,
        name: d.name,
      }));

      if (serialNumber || page === 0) {
        setDevicesArray((prev) => {
          const selected = prev.filter((d) => selectedDevices.includes(d.id));

          const newDevices = devicesNameIdMap.filter(
            (d) => !selectedDevices.includes(d.id),
          );

          return [...selected, ...newDevices];
        });
      } else {
        const newDevices = devicesNameIdMap.filter((d) => {
          if (deviceId !== d.id) {
            return !selectedDevices.includes(d.id);
          } else {
            return true;
          }
        });
        setDevicesArray((prev) => [...prev, ...newDevices]);
      }

      setLoadingDevices(false);
    },
    [selectedDevices, deviceId],
  );

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (serialNumber) {
      setCurrentPage(0);
    }

    if (currentPage === -1) return;

    fetchAllDevices(serialNumber, true, currentPage);
  }, [currentPage, serialNumber, fetchAllDevices]);

  const isSlaveChanged = (slave) => {
    const original = originalData[slave.id];
    return JSON.stringify(slave) !== JSON.stringify(original);
  };

  const writeFunctionCodes = {
    'Read Only': -1,
    'Write Coil': 5,
    '6 Label': 6,
    '16 Label': 16,
  };

  const ParamTypes = {
    '32bit float': 3,
    '32bit uint': 2,
    '32bit int': 18,
    Str: 42,
    '16bit float': 26,
    '16bit int': 14,
    '16bit uint': 1,
    Bool: 43,
  };

  const RegisterDataType = {
    DCBA: 1,
    BADC: 3,
    Bool: 2,
  };

  const Actions = {
    'Read Only': 0,
    'Read Write': 1,
  };

  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [interfaceIdMap, setInterfaceIdMap] = useState({});
  const [modbusConfigMap, setmodbusConfigMap] = useState({});
  const [interfaceNumberMap, setInterfaceNumberMap] = useState({});
  const [selectedModbusConfigId, setSelectedModbusConfigId] = useState(() => {
    // Try to load from localStorage first
    return localStorage.getItem('selectedModbusConfigId') || '';
  });
  // const errorCancelRef = useRef();

  const showError = (message) => {
    setErrorMessage(message);
    setIsErrorOpen(true);
  };

  const confirmDelete = (type, slaveId, paramId = null) => {
    setDeleteTarget({ type, slaveId, paramId });
    setIsDeleteOpen(true);
  };

  const defaultParameter = {
    id: uuidv4(),
    name: '',
    fn_code: 3,
    address: 0,
    type: 43,
    factor: 1,
    register_count: 1,
    register_data_type: 1,
    offset: 0,
    write_fn_code: -1,
    action: 0,
  };

  const handleDeleteConfirmed = () => {
    if (deleteTarget.type === 'slave') {
      setConfigurations((prev) =>
        prev.filter((slave) => slave.id !== deleteTarget.slaveId),
      );
    } else if (deleteTarget.type === 'parameter') {
      setConfigurations((prev) =>
        prev.map((slave) => {
          if (slave.id !== deleteTarget.slaveId) return slave;
          // Remove parameter, do NOT increment version here
          return {
            ...slave,
            parameters: slave.parameters.filter(
              (param) => param.id !== deleteTarget.paramId,
            ),
          };
        }),
      );
    }
    setIsDeleteOpen(false);
    setDeleteTarget({ type: null, slaveId: null, paramId: null });
  };

  const fetchInterfaces = useCallback(async () => {
    try {
      const keys = 'interfaces,modbus_configs';
      const resp = await axiosInstance.get(
        apiUrls.groupAttributes(deviceId, keys),
      );
      const attrMap = Object.fromEntries(
        resp.data.map((a) => [a.key, a.value]),
      );

      setInterfaceList(attrMap.interfaces || []);

      const settingsMap = {};
      (attrMap.interfaces || []).forEach((iface) => {
        // iface.interface is the interface_id
        if (iface.interface) {
          settingsMap[iface.interface] = iface.settings || {};
        }
      });
      setInterfaceSettingsMap(settingsMap);

      const modbusConfigMap = attrMap.modbus_configs.reduce((acc, i) => {
        const id = i.id || '';
        const name = i.name || '';
        acc[name] = id;
        return acc;
      }, {});

      setmodbusConfigMap(modbusConfigMap);

      // Auto-select the first configuration when available
      if (attrMap.modbus_configs?.length > 0 && !selectedModbusConfigId) {
        const firstConfigId = attrMap.modbus_configs[0]?.id;
        if (firstConfigId) {
          setSelectedModbusConfigId(firstConfigId);
        }
      }

      const interfaceIdMap = attrMap.interfaces.reduce((acc, i) => {
        const id = i.interface || '';
        const name = i.name || '';
        acc[name] = id;
        return acc;
      }, {});

      const interfaceNumberMap = attrMap.interfaces.reduce((acc, i) => {
        const id = i.id || '';
        const num = i.settings.interface;
        acc[id] = num;
        return acc;
      }, {});

      setInterfaceIdMap(interfaceIdMap);
      setInterfaceNumberMap(interfaceNumberMap);
    } catch (err) {
      console.error('Failed to fetch configurations', err);
    } finally {
      setLoading(false);
    }
  }, [deviceId, selectedModbusConfigId]);

  useEffect(() => {
    fetchInterfaces();
  }, [fetchInterfaces]);

  // Auto-select first configuration when modbusConfigMap is populated
  useEffect(() => {
    if (Object.keys(modbusConfigMap).length > 0 && !selectedModbusConfigId) {
      const firstConfigName = Object.keys(modbusConfigMap)[0];
      const firstConfigId = modbusConfigMap[firstConfigName];
      if (firstConfigId) {
        setSelectedModbusConfigId(firstConfigId);
      }
    }
  }, [modbusConfigMap, selectedModbusConfigId]);

  const addSlave = () => {
    // Check against max_modbus_slave
    if (configurations.length >= Number(maxSlavePerDevice)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlavePerDevice} slaves.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    if (deviceType === 1 && configurations.length >= maxSlavePerDevice) {
      showError(
        `You cannot add more than ${maxSlavePerDevice} slaves for device type 1.`,
      );
      return;
    }

    if (deviceType === 2) {
      const interfaceCounts = configurations.reduce((acc, slave) => {
        acc[slave.interface] = (acc[slave.interface] || 0) + 1;
        return acc;
      }, {});

      const canAdd = Object.values(interfaceCounts).every(
        (count) => count < maxSlavePerInterFace,
      );

      if (!canAdd) {
        showError(
          `Each interface can only have ${maxSlavePerInterFace} slaves for device type 2.`,
        );
        return;
      }
    }

    // Duplicate slave name check (case-insensitive, trimmed)
    const trimmedNames = configurations
      .map((s) => (s.name || '').trim().toLowerCase())
      .filter((n) => n); // ignore empty names
    // No need to check for '' here, allow empty name for new slave
    // (block on update if needed)

    const newSlave = {
      id: uuidv4(),
      name: '',
      slaveid: '',
      slaveip: '',
      interface: interfaceIdMap[0],
      parameters: [],
    };

    setConfigurations((prev) => [...prev, newSlave]);
    setOriginalData((prev) => ({ ...prev, [newSlave.id]: newSlave }));
  };

  const updateSlave = (id, field, value) => {
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === id
          ? {
              ...slave,
              [field]: value,
            }
          : slave,
      ),
    );
  };

  const addParameter = (slaveId) => {
    const targetSlave = configurations.find((s) => s.id === slaveId);
    if (!targetSlave) return;

    // Check against max_modbus_params_per_slave
    if (targetSlave.parameters.length >= Number(maxSlaveParameters)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlaveParameters} parameters per slave.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    // if (defaultParameter.name.length > 8) {
    //   toast({
    //     title: 'Parameter Name Too Long',
    //     description: 'Parameter name should not exceed 8 characters.',
    //     status: 'error',
    //     duration: 3000,
    //     position: 'top',
    //     isClosable: true,
    //   });
    //   return;
    // }

    // Check for duplicate parameter name (exact match, case-insensitive, trimmed, non-empty, only within this slave)
    if (
      defaultParameter.name &&
      targetSlave.parameters.some(
        (param) =>
          param.name &&
          param.name.trim().toLowerCase() ===
            defaultParameter.name.trim().toLowerCase(),
      )
    ) {
      toast({
        title: 'Duplicate Parameter Name',
        description: 'Parameter name must be unique within a slave.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    const param = { ...defaultParameter, id: uuidv4() };
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === slaveId
          ? { ...slave, parameters: [...slave.parameters, param] }
          : slave,
      ),
    );

    // Go to last page after adding parameter
    setParamPages((prev) => {
      const newParamCount = (targetSlave.parameters.length || 0) + 1;
      const lastPage = Math.floor((newParamCount - 1) / 10);
      return { ...prev, [slaveId]: lastPage };
    });
  };

  const updateParameter = (slaveId, paramId, field, value) => {
    // Only check for name length, not duplicates
    // if (field === 'name' && value.length > 8) {
    //   toast({
    //     title: 'Parameter Name Too Long',
    //     description: 'Parameter name should not exceed 8 characters.',
    //     status: 'error',
    //     duration: 3000,
    //     position: 'top',
    //     isClosable: true,
    //   });
    //   return;
    // }
    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id !== slaveId) return slave;
        return {
          ...slave,
          parameters: slave.parameters.map((param) =>
            param.id === paramId ? { ...param, [field]: value } : param,
          ),
        };
      }),
    );
  };

  const [deleteTarget, setDeleteTarget] = useState({
    type: null, //
    slaveId: null,
    paramId: null,
  });
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  // const cancelRef = useRef();

  const handleSave = (slave) => {
    // Duplicate slave name check (case-insensitive, trimmed, non-empty, excluding self)
    const trimmedSlaveName = (slave.name || '').trim().toLowerCase();
    if (
      trimmedSlaveName &&
      configurations.some(
        (s) =>
          s.id !== slave.id &&
          s.name &&
          s.name.trim().toLowerCase() === trimmedSlaveName,
      )
    ) {
      // Find all duplicate slave names
      const duplicateNames = configurations
        .filter(
          (s) =>
            s.id !== slave.id &&
            s.name &&
            s.name.trim().toLowerCase() === trimmedSlaveName,
        )
        .map((s) => s.name)
        .join(', ');
      toast({
        title: 'Duplicate Slave Name',
        description: `Slave name must be unique. Duplicate: ${slave.name}${
          duplicateNames ? ` (also: ${duplicateNames})` : ''
        }`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    // Duplicate parameter name check (case-insensitive, trimmed, non-empty, within this slave)
    const paramNames = new Set();
    let duplicateParamName = '';
    for (const param of slave.parameters || []) {
      const trimmedParamName = (param.name || '').trim().toLowerCase();
      if (trimmedParamName) {
        if (paramNames.has(trimmedParamName)) {
          duplicateParamName = param.name;
          break;
        }
        paramNames.add(trimmedParamName);
      }
    }
    if (duplicateParamName) {
      // Find all duplicate parameter names in this slave
      const nameCounts = {};
      (slave.parameters || []).forEach((param) => {
        const key = (param.name || '').trim().toLowerCase();
        if (key) nameCounts[key] = (nameCounts[key] || 0) + 1;
      });
      const duplicates = Object.entries(nameCounts)
        .filter(([_, count]) => count > 1)
        .map(([name]) => name)
        .join(', ');
      toast({
        title: 'Duplicate Parameter Name',
        description: `Parameter names must be unique within a slave. Duplicate: ${duplicates}`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    setConfigurations((prev) => {
      // Find the index of the existing slave
      const index = prev.findIndex((s) => s.id === slave.id);

      let newVersion;

      if (index === -1) {
        // This is a NEW slave
        // Find the maximum version among all existing slaves
        const versions = prev.map((s) => s.version || 1);
        const maxVersion = versions.length ? Math.max(...versions) : 0;
        newVersion = maxVersion + 1;
      } else {
        // This is an EXISTING slave
        const existingSlave = prev[index];
        const original = originalData[slave.id];

        if (original && JSON.stringify(slave) !== JSON.stringify(original)) {
          // Slave has CHANGED - increment its version (current version + 1)
          newVersion = (existingSlave.version || 1) + 1;
        } else {
          // No change - keep the same version
          newVersion = existingSlave.version || 1;
        }
      }

      const updatedSlave = {
        ...slave,
        version: newVersion,
      };

      toast({
        title: 'Slave Saved.',
        description: `Slave ${
          slave.name || slave.id
        } added to the device configuration.`,
        status: 'success',
        duration: 2000,
        position: 'top',
        isClosable: true,
      });

      // Update original data with the saved version
      setOriginalData((prevOriginal) => ({
        ...prevOriginal,
        [slave.id]: JSON.parse(JSON.stringify(updatedSlave)),
      }));

      // Update the configurations array
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = updatedSlave;
        return updated;
      } else {
        return [...prev, updatedSlave];
      }
    });
  };

  const handleSaveConfigurations = async () => {
    try {
      // Step 1: Fetch the current modbus_config to get existing versions
      let existingSlaveVersions = {};
      let serverMaxVersion = 0;

      try {
        const resp = await axiosInstance.get(
          apiUrls.toolDeviceAttributes(
            deviceId,
            'modbus_config,modbus_config_v',
          ),
        );
        const attrMap = Object.fromEntries(
          resp.data.map((a) => [a.key, a.value]),
        );
        const modbusConfig = attrMap['modbus_config'];

        if (modbusConfig?.slave_list?.length) {
          // Map slave UUID to version for quick lookup
          modbusConfig.slave_list.forEach((slave) => {
            if (slave.uuid) {
              existingSlaveVersions[slave.uuid] = slave.version || 1;
              // Track the maximum version from server
              serverMaxVersion = Math.max(serverMaxVersion, slave.version || 1);
            }
          });
        }
      } catch (err) {
        console.error('Error fetching modbus_config for versioning', err);
        // Continue with empty existingSlaveVersions
      }

      // Step 2: Calculate versions for all slaves
      const slavesConfigWithVersions = configurations.map((slave) => {
        const isNew = !existingSlaveVersions.hasOwnProperty(slave.id);
        const original = originalData[slave.id];
        const isChanged = original
          ? JSON.stringify(slave) !== JSON.stringify(original)
          : true;

        let version;

        // If slave already has a version from local updates, use it
        if (slave.version && !isNew) {
          // Use the locally updated version if available
          version = slave.version;
        } else if (isNew) {
          // For new slaves: get the maximum version from all slaves (including server ones)
          const allCurrentVersions = configurations
            .filter((s) => !isNew || s.id !== slave.id) // Exclude other new slaves
            .map((s) => s.version || 1);
          const maxCurrentVersion = Math.max(
            ...allCurrentVersions,
            serverMaxVersion,
            0,
          );
          version = maxCurrentVersion + 1;
        } else if (isChanged) {
          // For changed slaves: increment from existing version
          version = (existingSlaveVersions[slave.id] || 1) + 1;
        } else {
          // No change: keep existing version
          version = existingSlaveVersions[slave.id] || 1;
        }

        // Clean parameters based on GRIDX_TYPE
        const cleanedParameters = slave.parameters.map((param) => {
          const { id, ...restWithoutId } = param;
          if (GRIDX_TYPE === '2') {
            const { access, ...rest } = restWithoutId;
            return {
              ...rest,
              action: param.action || 0,
            };
          } else {
            const { action, ...rest } = restWithoutId;
            return {
              ...rest,
              access: param.access || 0,
            };
          }
        });

        const interfaceName = getInterfaceNameById(slave.interface_id);
        const isModbusTCP = interfaceName === 'Modbus_TCP';

        let slavePayload = {
          interface_id: slave?.interface_id,
          id: slave?.id || '',
          version,
          slave_id: slave?.slaveid || '',
          slave_name: slave?.name || '',
          parameters: cleanedParameters,
        };

        if (isModbusTCP) {
          let slave_ip =
            slave.slaveip !== undefined ? String(slave.slaveip) : '';

          // let slave_port =
          //   slave.port !== undefined && slave.port !== ''
          //     ? Number(slave.port)
          //     : '';

          // if (isNaN(slave_port)) slave_port = 502;

          slavePayload.slave_ip = slave_ip;
          // slavePayload.slave_port = slave_port;
        }

        return slavePayload;
      });

      // console.log(
      //   'Current configurations with versions:',
      //   configurations.map((s) => ({
      //     id: s.id,
      //     name: s.name,
      //     version: s.version,
      //   })),
      // );
      // console.log(
      //   'Saving with versions:',
      //   slavesConfigWithVersions.map((s) => ({
      //     id: s.id,
      //     name: s.slave_name,
      //     version: s.version,
      //   })),
      // );

      // Step 3: Prepare the payload
      const modbusConfigPayload = {
        addConfigToDevice: 1,
        config_id: configId,
        config_name: configName,
        slaves_config: slavesConfigWithVersions,
      };

      // console.log(
      //   'Saving config payload:',
      //   JSON.stringify(modbusConfigPayload, null, 2),
      // );

      // Step 4: Send to server for each selected device
      for (const deviceId of selectedDevices) {
        try {
          const response = await axiosInstance.post(
            apiUrls.updateDeviceModbus(deviceId),
            modbusConfigPayload,
          );

          if (response.status === 200) {
            // Update originalData with current state for this device
            const updatedOriginals = {};
            configurations.forEach((slave) => {
              updatedOriginals[slave.id] = JSON.parse(JSON.stringify(slave));
            });

            setOriginalData(updatedOriginals);

            toast({
              title: `Configuration Saved for Device`,
              description:
                response.data.success || 'Configuration saved successfully',
              status: 'success',
              duration: 3000,
              position: 'top',
              isClosable: true,
            });
          } else {
            throw new Error('Unexpected response status');
          }
        } catch (err) {
          console.error(`Error saving config for device ${deviceId}:`, err);

          // Check if it's a version conflict
          if (
            err.response?.status === 409 ||
            err.response?.data?.error?.includes('version')
          ) {
            toast({
              title: 'Version Conflict',
              description:
                'Configuration has been modified by another user. Please refresh and try again.',
              status: 'error',
              position: 'top',
              duration: 5000,
              isClosable: true,
            });

            fetchModbusConfigurations();
          } else {
            toast({
              title: 'Error',
              description:
                err.response?.data?.error || 'Unknown error occurred',
              status: 'error',
              position: 'top',
              duration: 3000,
              isClosable: true,
            });
          }
        }
      }

      onCloseSaveConf();

      // Refresh the configuration data to get updated versions
      await fetchModbusConfigurations();
    } catch (err) {
      console.error('Save failed:', err);
      toast({
        title: 'Save Failed',
        description: 'Could not save the configurations. Please try again.',
        status: 'error',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const fetchModbusData = useCallback(async () => {
    try {
      // Step 1: Fetch modbus_config
      const resp = await axiosInstance.get(
        apiUrls.getModbusData(selectedModbusConfigId),
      );

      const attrMap = Object.fromEntries(
        resp.data.map((a) => [a.key, a.value]),
      );
      const modbusConfig = attrMap['modbus_config'];
      // setSelectedModbusConfigId(modbusConfig?.id);

      setConfigName(modbusConfig?.name || '');
      setConfigId(modbusConfig?.id || '');

      if (!modbusConfig?.slave_list?.length) {
        console.warn('No slave_list found.');
        return;
      }

      const mergedConfigurations = modbusConfig.slave_list.map((slave) => {
        const config = slave.config || {};
        const meta = attrMap[slave.uuid] || {};

        return {
          id: slave.uuid,
          name: meta.name || '',
          slaveid: config.slaveid || '',
          slaveip: config.slaveip || '',
          interface_id: config.interface_id ?? 0,
          method: config.method?.toLowerCase() || '',
          port: config.port || '',
          baudrate: config.baudrate || 9600,
          timeout: config.timeout || 1000,
          parity: config.parity || 'N',
          stopbit: config.stopbit || 1,
          bytesize: config.bytesize || 8,
          pollperiod: config.pollperiod || 1000,
          host: config.host || '',
          parameters: (meta.parameters || []).map((param) => ({
            ...param,
            id: param.id || uuidv4(), // Assign ID if missing
          })),
          model: '',
          make: '',
          type: '',
          protocol: '',
          version: slave.version,
        };
      });

      setConfigurations(mergedConfigurations);
      setOriginalData(() => {
        const data = {};
        mergedConfigurations.forEach((slave) => {
          data[slave.id] = JSON.parse(JSON.stringify(slave));
        });
        return data;
      });
    } catch (err) {
      console.error('Error loading configuration:', err);
    }
  }, [selectedModbusConfigId]);

  useEffect(() => {
    // Only fetch if selectedModbusConfigId is valid (exists in modbusConfigMap)
    if (
      selectedModbusConfigId &&
      Object.values(modbusConfigMap).includes(selectedModbusConfigId)
    ) {
      fetchModbusData();
    }
  }, [selectedModbusConfigId, modbusConfigMap, fetchModbusData]);
  const fetchDeviceInterfaces = useCallback(async () => {
    let keys = [
      'app_version',
      'device_type',
      'patch_v',
      'max_modbus_slave',
      'max_slave_per_interface',
      'max_modbus_params_per_slave',
      'rs485_1',
      'rs485_2',
      'rs485_3',
      'tcp',
    ];
    keys = keys.join(',');
    try {
      const resp = await axiosInstance.get(
        apiUrls.toolDeviceAttributes(deviceId, keys),
      );
      // console.log('tool data------->', JSON.stringify(resp));

      const attrs = resp.data;
      const attrMap = Object.fromEntries(attrs.map((a) => [a.key, a.value]));

      setDeviceType(attrMap.device_type || 1);
      setMaxSlavePerDevice(attrMap.max_modbus_slave || 1);
      setMaxSlavePerInterFace(attrMap.max_slave_per_interface || 1);
      setMaxSlaveParameters(attrMap.max_modbus_params_per_slave || 5);
    } catch (err) {
      console.error('Error fetching attributes', err);
    } finally {
      setLoading(false);
    }
  }, [deviceId]); // add deviceId as dependency

  const handleCheckboxChange = (id) => {
    setSelectedDevices((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id],
    );
  };

  const fetchModbusConfigurations = useCallback(async () => {
    if (!deviceId) return;

    try {
      // Step 1: Fetch modbus_config
      const resp = await axiosInstance.get(
        apiUrls.toolDeviceAttributes(deviceId, 'modbus_config,modbus_config_v'),
      );

      const attrMap = Object.fromEntries(
        resp.data.map((a) => [a.key, a.value]),
      );
      const modbusConfig = attrMap['modbus_config'];

      setConfigName(modbusConfig?.name || '');
      setConfigId(modbusConfig?.id || '');

      if (modbusConfig?.id) {
        setSelectedModbusConfigId(modbusConfig.id);
        localStorage.setItem('selectedModbusConfigId', modbusConfig.id);
      }

      if (!modbusConfig?.slave_list?.length) {
        console.warn('No slave_list found.');
        return;
      }

      // Step 2: Extract slave UUIDs
      const slaveUUIDs = modbusConfig.slave_list.map((s) => s.uuid).join(',');

      // Step 3: Fetch metadata for all slaves
      const metaResp = await axiosInstance.get(
        apiUrls.toolDeviceAttributes(deviceId, slaveUUIDs),
      );
      const metaMap = Object.fromEntries(
        metaResp.data.map((a) => [a.key, a.value]),
      );

      // Step 4: Merge configs
      const mergedConfigurations = modbusConfig.slave_list.map((slave) => {
        const config = slave.config || {};
        const meta = metaMap[slave.uuid] || {};

        return {
          id: slave.uuid,
          name: meta.name || '',
          slaveid: config.slaveid || '',
          slaveip: config.slaveip || '',
          interface_id: config.interface_id ?? 0,
          method: config.method?.toLowerCase() || '',
          port: config.port || '',

          baudrate: config.baudrate || 9600,
          timeout: config.timeout || 1000,
          parity: config.parity || 'N',
          stopbit: config.stopbit || 1,
          bytesize: config.bytesize || 8,
          pollperiod: config.pollperiod || 1000,
          host: config.host || '',
          parameters: (meta.parameters || []).map((param) => ({
            ...param,
            id: param.id || uuidv4(), // Assign ID if missing
          })),
          model: '',
          make: '',
          type: '',
          protocol: '',
          version: slave.version,
        };
      });

      setConfigurations(mergedConfigurations);
      setOriginalData(() => {
        const data = {};
        mergedConfigurations.forEach((slave) => {
          data[slave.id] = JSON.parse(JSON.stringify(slave));
        });
        return data;
      });
    } catch (err) {
      console.error('Error loading configuration:', err);
    }
  }, [deviceId]);

  useEffect(() => {
    fetchModbusConfigurations();
  }, [fetchModbusConfigurations]);

  useEffect(() => {
    fetchDeviceInterfaces();
  }, [fetchDeviceInterfaces]);

  const updateSlaveParams = (parameters) => {
    if (!currentSlaveId || !parameters || !Array.isArray(parameters)) {
      console.error('Invalid parameters or no slave selected');
      return;
    }

    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id === currentSlaveId) {
          // Add the new parameters to existing ones
          const newParameters = parameters.map((param) => ({
            id: param.id || uuidv4(),
            name: param.name || '',
            fn_code: param.fnCode || 3,
            address: param.address || 0,
            type: ParamTypes[param.type] || 43,
            factor: param.factor || 1,
            register_count: param.regCount || 1,
            register_data_type: RegisterDataType[param.regDataType] || 1,
            offset: param.offset || 0,
            write_fn_code: writeFunctionCodes[param.writeFn] || -1,
            action: Actions[param.access] || 0,
          }));

          return {
            ...slave,
            parameters: [...slave.parameters, ...newParameters],
          };
        }
        return slave;
      }),
    );
  };

  const addBulkParameters = () => {
    // Find the next available slaveid starting from 3
    const existingSlaveIds = configurations
      .map((s) => Number(s.slaveid))
      .filter((n) => !isNaN(n));
    let nextSlaveId = 3;
    const slavesToAdd = [];
    const interfaceId = Object.values(interfaceIdMap)[3] || 0;

    for (let i = 0; i < 31; i++) {
      // Find the next unused slaveid
      while (existingSlaveIds.includes(nextSlaveId)) {
        nextSlaveId++;
      }
      const slaveName = `test-slave${nextSlaveId}`;
      const newSlaveId = uuidv4();
      const bulkParams = Array.from({ length: 1000 }, (_, j) => ({
        ...defaultParameter,
        id: uuidv4(),
        name: `${slaveName}_temp_${j + 1}`,
        address: j + 1,
        register_count: 2,
        register_data_type: 1,
        offset: 0,
        write_fn_code: -1,
        action: 0,
      }));
      slavesToAdd.push({
        id: newSlaveId,
        name: slaveName,
        slaveid: nextSlaveId,
        slaveip: '',
        interface: interfaceId,
        interface_id: interfaceId,
        parameters: bulkParams,
      });
      existingSlaveIds.push(nextSlaveId);
      nextSlaveId++;
    }

    setConfigurations((prev) => [...prev, ...slavesToAdd]);
    setOriginalData((prev) => {
      const updated = { ...prev };
      slavesToAdd.forEach((slave) => {
        updated[slave.id] = slave;
      });
      return updated;
    });
  };

  const showAllColumns = GRIDX_TYPE === '2';
  const [expandedSlaves, setExpandedSlaves] = useState({});

  const toggleSlaveExpand = (slaveId) => {
    setExpandedSlaves((prev) => ({
      ...prev,
      [slaveId]: !prev[slaveId],
    }));
  };

  // Pagination state: track current page per slave
  const [paramPages, setParamPages] = useState({});

  // Helper: get paginated parameters for a slave
  const getPaginatedParameters = (slave) => {
    const page = paramPages[slave.id] || 0;
    const pageSize = 10;
    const start = page * pageSize;
    const end = start + pageSize;
    return slave.parameters.slice(start, end);
  };

  // Helper: total pages for a slave
  const getTotalPages = (slave) => {
    return Math.ceil((slave.parameters?.length || 0) / 10);
  };

  // Handler: change page for a slave
  const handleParamPageChange = (slaveId, newPage) => {
    setParamPages((prev) => ({
      ...prev,
      [slaveId]: newPage,
    }));
  };
  useEffect(() => {
    if (configurations.length > 0) {
      const allExpanded = {};
      configurations.forEach((slave) => {
        allExpanded[slave.id] = true;
      });
      setExpandedSlaves(allExpanded);
    }
  }, [configurations]);

  // When user changes config, update state and localStorage
  const handleModbusConfigChange = (selectedConfig) => {
    setSelectedModbusConfigId(selectedConfig);
    localStorage.setItem('selectedModbusConfigId', selectedConfig);
  };

  // On mount, if localStorage has a value and it's valid, use it
  useEffect(() => {
    const storedConfigId = localStorage.getItem('selectedModbusConfigId');
    if (
      storedConfigId &&
      Object.values(modbusConfigMap).includes(storedConfigId)
    ) {
      setSelectedModbusConfigId(storedConfigId);
    }
  }, [Object.keys(modbusConfigMap).length]);

  useEffect(() => {
    if (Object.keys(modbusConfigMap).length > 0 && !selectedModbusConfigId) {
      const firstConfigId = Object.values(modbusConfigMap)[0];
      if (firstConfigId) {
        setSelectedModbusConfigId(firstConfigId);
        localStorage.setItem('selectedModbusConfigId', firstConfigId);
      }
    }
  }, [modbusConfigMap, selectedModbusConfigId]);

  // Helper to get interface name by interface_id
  const getInterfaceNameById = (interface_id) => {
    const iface = interfaceList.find((i) => i.interface === interface_id);
    return iface ? iface.name : '';
  };

  // Helper to get interface settings by interface_id
  const getInterfaceSettingsById = (interface_id) => {
    return interfaceSettingsMap[interface_id] || {};
  };

  return (
    <>
      {loading ? (
        <TableSkeleton rowCount={5} columnCount={12} />
      ) : (
        <Box color={textColor}>
          <Flex justify="space-between" mt={1} align="center">
            <Heading size="lg" mb={6}>
              Slave Configurations
            </Heading>

            {/* Group interface select + buttons on the right */}
            <Flex align="center">
              {Object.keys(modbusConfigMap).length > 0 && (
                <Box mr={3}>
                  <Flex>
                    <Text me="3" mt={1} fontWeight="600">
                      Config:
                    </Text>
                    <InterfaceSelect
                      value={
                        selectedModbusConfigId ||
                        Object.values(modbusConfigMap)[0]
                      }
                      options={modbusConfigMap}
                      onChange={handleModbusConfigChange}
                    />
                  </Flex>
                </Box>
              )}

              {/* Buttons grouped together with no gap */}
              <Flex align="center">
                <Button
                  size="sm"
                  colorScheme="green"
                  variant="outline"
                  border="2px"
                  cursor="pointer"
                  onClick={() => {
                    // navigate to the same EditDevice route and request tab index 2 (Add Configuration)
                    navigate(location.pathname, { state: { activeTab: 2 } });
                  }}
                >
                  Add More Configuration
                </Button>
                <Button
                  size="sm"
                  colorScheme="green"
                  variant="outline"
                  border="2px"
                  cursor="pointer"
                  onClick={() => {
                    onOpenSaveConf();
                    setCurrentPage(0);
                    setDevicesArray([]);
                  }}
                  ml={1} // very small space (4px) between the two buttons
                >
                  Save Configuration
                </Button>
              </Flex>
            </Flex>
          </Flex>
          {configurations.map((slave) => {
            const interfaceName = getInterfaceNameById(slave.interface_id);
            const isModbusTCP = interfaceName === 'Modbus_TCP';
            // const defaultPort =
            //   slave.port !== undefined && slave.port !== '' ? slave.port : 502;
            return (
              <Card key={slave.id} bg={cardBg} p={4} my={4} color={textColor}>
                {/* Slave Info Table */}
                <Table size="sm" mb={4}>
                  <Thead>
                    <Tr>
                      <Th textAlign={'center'} borderColor="transparent">
                        Name
                      </Th>
                      <Th textAlign={'center'} borderColor="transparent">
                        Slave ID
                      </Th>
                      {/* Move TCP fields before Interface if Modbus_TCP */}
                      {isModbusTCP && (
                        <>
                          <Th textAlign={'center'} borderColor="transparent">
                            Slave IP
                          </Th>
                          {/* <Th textAlign={'center'} borderColor="transparent">
                            Slave Port
                          </Th> */}
                        </>
                      )}
                      <Th textAlign={'center'} borderColor="transparent">
                        Interface
                      </Th>
                      {/* ...existing code... */}
                      <Th borderColor="transparent" textAlign="center" />
                      <Th borderColor="transparent" textAlign="center" />
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td borderColor="transparent" ps={0}>
                        <Default
                          size="sm"
                          fontSize="lg"
                          placeholder="slave name"
                          value={slave.name}
                          onChange={(e) =>
                            updateSlave(slave.id, 'name', e.target.value)
                          }
                          bg={inputBg}
                          color={textColor}
                        />
                      </Td>
                      <Td borderColor="transparent" ps={0}>
                        <Default
                          size="sm"
                          fontSize="md"
                          type="number"
                          placeholder="slave id"
                          value={slave.slaveid}
                          onChange={(e) => {
                            const val = e.target.value;
                            updateSlave(
                              slave.id,
                              'slaveid',
                              val === '' ? '' : Number(val),
                            );
                          }}
                          bg={inputBg}
                          color={textColor}
                        />
                      </Td>
                      {/* Move TCP fields before Interface if Modbus_TCP */}
                      {isModbusTCP && (
                        <>
                          <Td borderColor="transparent" ps={0}>
                            <Default
                              size="sm"
                              fontSize="md"
                              placeholder="slave ip"
                              value={slave.slaveip}
                              onChange={(e) =>
                                updateSlave(slave.id, 'slaveip', e.target.value)
                              }
                              bg={inputBg}
                              color={textColor}
                            />
                          </Td>
                          {/* <Td borderColor="transparent" ps={0}>
                            <Default
                              size="sm"
                              fontSize="md"
                              placeholder="slave port"
                              value={
                                slave.port === undefined || slave.port === ''
                                  ? ''
                                  : slave.port
                              }
                              onChange={(e) => {
                                const val = e.target.value;
                                updateSlave(
                                  slave.id,
                                  'port',
                                  val === '' ? '' : Number(val),
                                );
                              }}
                              bg={inputBg}
                              color={textColor}
                            />
                          </Td> */}
                        </>
                      )}
                      <Td borderColor="transparent" ps={0}>
                        <InterfaceSelect
                          value={slave.interface_id}
                          options={interfaceIdMap}
                          onChange={(selectedInterface) =>
                            updateSlave(
                              slave.id,
                              'interface_id',
                              selectedInterface,
                            )
                          }
                        />
                      </Td>
                      {/* ...existing code... */}
                      <Td borderColor="transparent" textAlign="center" ps={0}>
                        {slave.parameters && slave.parameters.length > 0 && (
                          <Button
                            size="sm"
                            onClick={() => toggleSlaveExpand(slave.id)}
                            leftIcon={
                              expandedSlaves[slave.id] ? (
                                <ChevronDownIcon />
                              ) : (
                                <ChevronRightIcon />
                              )
                            }
                          />
                        )}
                      </Td>
                      <Td borderColor="transparent" textAlign="center" ps={0}>
                        <IconButton
                          aria-label="Remove slave"
                          icon={<DeleteIcon />}
                          size="sm"
                          colorScheme="red"
                          onClick={() => confirmDelete('slave', slave.id)}
                        />
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>

                <HSeparator />

                {/* Parameters Table - only show if expanded */}
                {expandedSlaves[slave.id] && slave.parameters.length > 0 && (
                  <Box overflowX="auto" maxWidth="100%">
                    <Table variant="simple" size="sm" mt={4}>
                      <Thead>
                        <Tr>
                          <Th borderColor="transparent" textAlign="center">
                            Name
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Fn Code
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Address
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Type
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Factor
                          </Th>
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Reg Count
                            </Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Register Data Type
                            </Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Offset
                            </Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Write Fn
                            </Th>
                          )}
                          <Th borderColor="transparent" textAlign="center">
                            Access
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Delete
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {getPaginatedParameters(slave).map((param, idx) => (
                          <Tr key={param.id || idx}>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                placeholder="e.g. tmp"
                                value={param.name}
                                onChange={(e) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'name',
                                    e.target.value,
                                  )
                                }
                                bg={inputBg}
                                color={textColor}
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                type="number"
                                value={param.fn_code}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'fn_code',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                type="number"
                                value={param.address}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'address',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <InterfaceSelect
                                value={param.type}
                                options={ParamTypes}
                                onChange={(val) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'type',
                                    val,
                                  )
                                }
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                type="number"
                                value={param.factor}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'factor',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                              />
                            </Td>
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <Default
                                  size="sm"
                                  type="number"
                                  value={param.register_count}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'register_count',
                                      val === '' ? '' : Number(val),
                                    );
                                  }}
                                  bg={inputBg}
                                  color={textColor}
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <InterfaceSelect
                                  value={param.register_data_type}
                                  options={RegisterDataType}
                                  onChange={(val) =>
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'register_data_type',
                                      val,
                                    )
                                  }
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <Default
                                  size="sm"
                                  type="number"
                                  value={param.offset}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'offset',
                                      val === '' ? '' : Number(val),
                                    );
                                  }}
                                  bg={inputBg}
                                  color={textColor}
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <InterfaceSelect
                                  value={param.write_fn_code}
                                  options={writeFunctionCodes}
                                  onChange={(val) =>
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'write_fn_code',
                                      val,
                                    )
                                  }
                                />
                              </Td>
                            )}
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <InterfaceSelect
                                value={param.access || 0}
                                options={Actions}
                                onChange={(val) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'access',
                                    val,
                                  )
                                }
                              />
                            </Td>
                            <Td
                              ps={0}
                              textAlign="center"
                              borderColor="transparent"
                            >
                              <IconButton
                                icon={<DeleteIcon />}
                                aria-label="Delete parameter"
                                size="sm"
                                colorScheme="red"
                                onClick={() =>
                                  confirmDelete('parameter', slave.id, param.id)
                                }
                              />
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    {/* Pagination Controls */}
                    <Flex justify="space-between" align="center" mt={2}>
                      <Button
                        size="md"
                        onClick={() =>
                          handleParamPageChange(
                            slave.id,
                            Math.max((paramPages[slave.id] || 0) - 1, 0),
                          )
                        }
                        isDisabled={(paramPages[slave.id] || 0) === 0}
                      >
                        <ChevronLeftIcon />
                      </Button>
                      <Center flex="1">
                        <Text fontSize="sm" mx={2}>
                          Page {(paramPages[slave.id] || 0) + 1} of{' '}
                          {getTotalPages(slave)}
                        </Text>
                      </Center>

                      <Button
                        size="md"
                        onClick={() =>
                          handleParamPageChange(
                            slave.id,
                            Math.min(
                              (paramPages[slave.id] || 0) + 1,
                              getTotalPages(slave) - 1,
                            ),
                          )
                        }
                        isDisabled={
                          (paramPages[slave.id] || 0) >=
                          getTotalPages(slave) - 1
                        }
                      >
                        <ChevronRightIcon />
                      </Button>
                    </Flex>
                  </Box>
                )}

                <AssetParamDialog
                  open={openAssetMastermodel}
                  onClose={closeAssetParameterModal}
                  updateSlaveParams={updateSlaveParams}
                />

                {/* <HSeparator /> */}

                <Flex justify="center" mt={3}>
                  <Button
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={() => handleSave(slave)}
                    isDisabled={!isSlaveChanged(slave)}
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    mx="2"
                    variant="outline"
                    border="2px"
                    colorScheme="orange"
                    cursor="pointer"
                    onClick={() => addParameter(slave.id)}
                  >
                    Add Parameter
                  </Button>
                  <Button
                    variant="outline"
                    border="2px"
                    colorScheme="orange"
                    size="sm"
                    cursor="pointer"
                    onClick={() => {
                      setCurrentSlaveId(slave.id);
                      setOpen(true);
                    }}
                  >
                    Add Asset
                  </Button>
                  {/* <Button
                    size="sm"
                    mx="2"
                    variant="outline"
                    border="2px"
                    colorScheme="blue"
                    cursor="pointer"
                    onClick={() => addBulkParameters(slave.id)}
                  >
                    Add 100 Example Parameters
                  </Button> */}
                </Flex>
              </Card>
            );
          })}

          <AssetParamDialog
            open={open}
            onClose={() => {
              setOpen(false);
              setCurrentSlaveId(null);
            }}
            updateSlaveParams={updateSlaveParams}
          />

          <Flex justify="center" mt={6}>
            <Button
              size="sm"
              mx="2"
              variant="outline"
              border="2px"
              colorScheme="orange"
              cursor="pointer"
              onClick={addSlave}
            >
              Add Slave
            </Button>
          </Flex>

          {/* Replace Delete AlertDialog */}
          <GlobalAlertDialog
            isOpen={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            onConfirm={handleDeleteConfirmed}
            title={
              deleteTarget.type === 'slave'
                ? 'Delete Slave'
                : 'Delete Parameter'
            }
            body={
              <>
                Are you sure you want to delete this{' '}
                {deleteTarget.type === 'slave' ? 'slave' : 'parameter'}? This
                action cannot be undone.
              </>
            }
            confirmText="Delete"
            cancelText="Cancel"
            showCancel={true}
          />

          {/* Replace Error AlertDialog */}
          <GlobalAlertDialog
            isOpen={isErrorOpen}
            onClose={() => setIsErrorOpen(false)}
            onConfirm={() => setIsErrorOpen(false)}
            title="Validation Error"
            body={errorMessage}
            confirmText="OK"
            showCancel={false}
          />

          <GlobalModal
            isOpen={isOpenSaveConf}
            onClose={() => {
              onCloseSaveConf();
              setCurrentPage(-1);
            }}
            title={`Save Configurations : ${deviceId}`}
            size="xl"
            bg={cardBg}
            minWidth="1200px"
            footer={
              <ModalFooter flexDirection="column" alignItems="center">
                {!configName && (
                  <Text fontSize="sm" color="red.500" mb={2}>
                    Config name is required.
                  </Text>
                )}
                <Box display="flex" w="100%" justifyContent="center">
                  <Button
                    size="sm"
                    colorScheme="orange"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    mr={3}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    isLoading={loadingDevices}
                    loadingText="Loading..."
                    spinnerPlacement="start"
                    isDisabled={serialNumber || !hasNext}
                  >
                    Load More
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    border="2px"
                    isDisabled={!configName}
                    onClick={handleSaveConfigurations}
                    cursor="pointer"
                    mr={3}
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="red"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    mr={3}
                    onClick={() => {
                      onCloseSaveConf();
                      setCurrentPage(-1);
                    }}
                  >
                    Close
                  </Button>
                </Box>
              </ModalFooter>
            }
          >
            <Flex justifyContent="space-between">
              <Default
                maxWidth="300px"
                // size="md"
                fontSize="lg"
                border="2px"
                mb="4"
                placeholder="Config Name"
                value={configName}
                onChange={(e) => setConfigName(e.target.value)}
                bg={inputBg}
                color={textColor}
              />
              <InputGroup width="400px" borderRadius="1rem">
                <InputLeftElement>
                  <SearchIcon borderRadius="2rem" color="navy.500" />
                </InputLeftElement>
                <Input
                  size="md"
                  borderRadius="1rem"
                  border="2px lightgray solid"
                  type="text"
                  value={serialNumber}
                  boxShadow="none"
                  onChange={(e) => setSerialNumber(e.target.value)}
                  color={textColor}
                  placeholder="Search Device..."
                  outline="none"
                  _focus={{ boxShadow: 'none' }}
                />
              </InputGroup>
            </Flex>
            <Box mt="3" p="2">
              <SimpleGrid columns={4} spacing={4} mt={3}>
                {devicesArray.map((d, index) => (
                  <Checkbox
                    // isChecked={d.id === deviceId}
                    isDisabled={d.id === deviceId}
                    key={d.id || index}
                    value={d.id}
                    onChange={() => handleCheckboxChange(d.id)}
                  >
                    {d.name}
                  </Checkbox>
                ))}
              </SimpleGrid>
            </Box>
          </GlobalModal>
        </Box>
      )}
    </>
  );
}
